// @flow
import { useCallback } from 'react';

export const useSafeCall = (callMethod, mountedRef) => useCallback((...args) => {
  if (!mountedRef || !mountedRef.current) {
    return undefined;
  }

  if (typeof callMethod !== 'function') {
    return undefined;
  }

  return callMethod(...args);
}, [callMethod, mountedRef]);

export default useSafeCall;
